export default function About() {
  return (
    <section id="about" className="py-24 bg-gradient-to-br from-white via-teal-50/30 to-orange-50/30">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6" style={{ fontFamily: 'Cairo, sans-serif' }}>
            عن مطعم فوكاتشيا
          </h2>
          <div className="w-32 h-1 bg-gradient-to-r from-teal-500 to-orange-500 mb-8"></div>
          <p className="text-xl text-gray-700 leading-relaxed mb-8">
            مطعم فوكاتشيا هو وجهتك المثالية للاستمتاع بتجربة طعام فندقية راقية على مدار الساعة. نحن نفخر بتقديم بوفيه فطور مفتوح يوميًا مع تشكيلة واسعة من الأطباق العالمية والمحلية الطازجة.
          </p>
        </div>

        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
            <div className="relative">
              <div className="relative w-full h-96 rounded-3xl overflow-hidden shadow-2xl">
                <img
                  src="https://public.readdy.ai/ai/img_res/dbf66323b56c044a7b02489636c7c015.jpg"
                  alt="Focaccia Restaurant Interior"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-gradient-to-br from-teal-500 to-orange-500 rounded-3xl -z-10"></div>
            </div>

            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Cairo, sans-serif' }}>
                تجربة طعام فندقية استثنائية
              </h3>
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                مطعم فوكاچيا هو وجهتك المثالية للاستمتاع بتجربة طعام فاخرة على مدار اليوم. نفخر بتقديم بوفيه فطور مفتوح يوميًا يضم أشهى المأكولات المحلية والعالمية، بالإضافة إلى قوائم غداء وعشاء متنوعة تلبي جميع الأذواق.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                نجمع بين الأصالة والفخامة في أجواء راقية، حيث يتم إعداد كل طبق بعناية فائقة من قبل طهاة محترفين باستخدام أجود المكونات الطازجة.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-gradient-to-br from-teal-500 to-teal-600 rounded-2xl p-8 text-white shadow-xl transform hover:scale-105 transition-all duration-300">
              <div className="w-16 h-16 flex items-center justify-center bg-white/20 rounded-2xl mb-6">
                <i className="ri-restaurant-line text-4xl"></i>
              </div>
              <h4 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Cairo, sans-serif' }}>
                بوفيه مفتوح يوميًا
              </h4>
              <p className="text-white/90 text-base leading-relaxed">
                استمتع ببوفيه فطور مفتوح غني بأشهى المأكولات المحلية والعالمية كل صباح
              </p>
            </div>

            <div className="bg-gradient-to-br from-orange-500 to-orange-600 rounded-2xl p-8 text-white shadow-xl transform hover:scale-105 transition-all duration-300">
              <div className="w-16 h-16 flex items-center justify-center bg-white/20 rounded-2xl mb-6">
                <i className="ri-restaurant-2-line text-4xl"></i>
              </div>
              <h4 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Cairo, sans-serif' }}>
                قوائم متنوعة
              </h4>
              <p className="text-white/90 text-base leading-relaxed">
                قوائم غداء وعشاء غنية بالأطباق الشرقية والعالمية لإرضاء جميع الأذواق
              </p>
            </div>

            <div className="bg-gradient-to-br from-pink-500 to-rose-600 rounded-2xl p-8 text-white shadow-xl transform hover:scale-105 transition-all duration-300">
              <div className="w-16 h-16 flex items-center justify-center bg-white/20 rounded-2xl mb-6">
                <i className="ri-star-smile-line text-4xl"></i>
              </div>
              <h4 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Cairo, sans-serif' }}>
                خدمة راقية
              </h4>
              <p className="text-white/90 text-base leading-relaxed">
                فريق محترف يقدم خدمة فندقية متميزة في أجواء أنيقة ومريحة
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
